// import { Avatar, Box, Button, Card, CardActions, CardHeader, CircularProgress, CssBaseline, Grid, IconButton, Modal, Paper, Stack, Typography, colors, useMediaQuery, useTheme } from '@mui/material'
// // import React from 'react'
// // import { Stack } from 'react-bootstrap'
// import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
// import FilterStrip from './FilterStrip';
// import SingleLineChart from './charts/SingleLineChart';
// import TempMeter from './charts/TempMeter';
// import TwoHeadTable from './TwoHeadTable';
// import { DT1, DT2, WEB_KEY } from '../api/AxiosApi';
// import { WmcContext } from '../context/WmcContext';
// import { getDateTimeForTab2, getFromTo, getGraphDateTime } from '../utils';
// import AppModal from './AppModal';
// // let TableHead;

// function TabContent({ WM_TYPE, tabTitle }) {
//     // const WM_TYPE = menuID
//     const { WmSensData, SensDataLoading, getWmSENS, SingleWmDash } = useContext(WmcContext)
//     const { palette, breakpoints, spacing } = useTheme()
//     const lgs = useMediaQuery(breakpoints.down('xl'))

//     const [FullScreen, setFullScreen] = useState(false)
    
//     const LOGIN_ID = localStorage.getItem('LoginID')
//     const LOC_CODE = localStorage.getItem('LCODE')
//     const [width, setWidth] = useState();
//     const [height, setHeight] = useState();
//     const [FromDate, setFromDate] = useState(getDateTimeForTab2().LastDay)
//     const [ToDate, setToDate] = useState(getDateTimeForTab2().Today)

//     const [datasets, setDatasets] = useState([])
//     const [labels, setLabels] = useState([])

//     const [open, setOpen] = useState(false);
//     const handleOpen = () => setOpen(true);
//     const handleClose = () => setOpen(false);

//     // const [FromDate, setFromDate] = useState(getDateTimeForTab2().LastDay)
//     // const [ToDate, setToDate] = useState(getDateTimeForTab2().Today)

//     const LCODE = localStorage.getItem('LCODE')

//     const PASS_KEY = "WERRRRRRRRRRR"


//   function onRefreshGarphData() {
//         if (FromDate.length !== 0 && ToDate.length !== 0) {
//             getWmSENS(LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY, WM_TYPE, FromDate, ToDate)
//         } else {
//             alert('please provide any date')
//         }

//     }

//     function onTblDataRefresh() {
//         if (FromDate.length !== 0 && ToDate.length !== 0) {
//             getWmSENS(LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY, WM_TYPE, FromDate, ToDate)
//         } else {
//             alert('please provide any date')
//         }

//     }


//     const SolarInsolationHeader = [
//         'Sn',
//         'Date Time',
//         'Solar Insolation',
//         'Peak Irradiance',
//         'Peak IRR.Time'
//     ]

//     const WindDirectionHeader = [
//         'Sn',
//         'Date Time',
//         'Wind Direction'
//     ]

//     const TableHead = [
//         'Sn',
//         'Date Time',
//         tabTitle,
//         'Minimum Value',
//         'Maximum Value',
//         'Average Value'
//     ]

//     // const TableData = [
//     //     {
//     //         'S.No.': '1',
//     //         'Date': '21/09/2023    10:10 AM',
//     //         'Ambient Temperature (Celsius)': '39.593'
//     //     },
//     //     {
//     //         'S.No.': '2',
//     //         'Date': '21/09/2023    10:10 AM',
//     //         'Ambient Temperature (Celsius)': '39.593'
//     //     },
//     //     {
//     //         'S.No.': '3',
//     //         'Date': '21/09/2023    10:10 AM',
//     //         'Ambient Temperature (Celsius)': '39.593'
//     //     },
//     //     {
//     //         'S.No.': '4',
//     //         'Date': '21/09/2023    10:10 AM',
//     //         'Ambient Temperature (Celsius)': '39.593'
//     //     },
//     //     {
//     //         'S.No.': '5',
//     //         'Date': '21/09/2023    10:10 AM',
//     //         'Ambient Temperature (Celsius)': '39.593'
//     //     }
//     // ]

//     // if (WmSensData?.length > 0) {
//     //     TableHead = Object?.keys(WmSensData[0])
//     // }


//     function getRandomColor() {
//         var letters = '0123456789ABCDEF';
//         var color = '#';
//         for (var i = 0; i < 6; i++) {
//             color += letters[Math.floor(Math.random() * 16)];
//         }
//         return color;
//     }
//     const styles = {
//         IconStyle: {
//             color: 'primary.main',
//             fontSize: '0.8rem'
//         }
//     }


//     useEffect(() => {
//         if (WmSensData?.length > 0) {
//             if (tabTitle == 'Solar Insolation') {
//                 setDatasets([
//                     {
//                         label: tabTitle,
//                         data: WmSensData?.map(item => item[tabTitle]),
//                         fill: false,
//                         borderWidth: 0.9,
//                         borderColor: 'green',
//                         tension: 0.3,
//                         pointRadius: 1,
//                         pointHoverRadius: 1

//                     },])
//                 setLabels(WmSensData?.map(item => item?.DateTime))

//             } else {
//                 setDatasets([
//                     {
//                         label: tabTitle,
//                         data: WmSensData?.map(item => item[tabTitle]),
//                         fill: false,
//                         borderWidth: 0.9,
//                         borderColor: 'green',
//                         tension: 0.3,
//                         pointRadius: 1,
//                         pointHoverRadius: 1
//                     },
//                     {
//                         label: 'Min',
//                         data: WmSensData?.map(item => item?.MIN_VALUE),
//                         fill: false,
//                         borderWidth: 0.9,
//                         borderColor: 'yellow',
//                         tension: 0.3,
//                         pointRadius: 1,
//                         pointHoverRadius: 1
//                     },
//                     {
//                         label: 'Max',
//                         data: WmSensData?.map(item => item?.MAX_VALUE),
//                         fill: false,
//                         borderColor: 'red',
//                         tension: 0.3,
//                         borderWidth: 0.9,
//                         pointRadius: 1,
//                         pointHoverRadius: 1

//                     }, {
//                         label: 'Avg',
//                         data: WmSensData?.map(item => item?.AVG_VALUE),
//                         fill: false,
//                         borderColor: 'blue',
//                         tension: 0.3,
//                         borderWidth: 0.9,
//                         pointRadius: 1,
//                         pointHoverRadius: 1
//                     }
//                 ])
//                 setLabels(WmSensData?.map(item => item?.DateTime))
//             }

//         }
//     }, [WmSensData])



//     return (
//         <>
//             <CssBaseline />
//             <Box bgcolor={'background.default'} py={spacing(1)}>
//                 <Grid container spacing={spacing(1)}>
//                     <Grid item md={8} sm={12}>
//                         <Stack spacing={spacing(1)}>

//                             <FilterStrip
//                                 title={tabTitle}
//                                 ValueOf1={FromDate}
//                                 ValueOf2={ToDate}
//                                 onChangeValueOf1={(val) => setFromDate(val.target.value)}
//                                 onChangeValueOf2={(val) => setToDate(val.target.value)}
//                                 onFullScreen={handleOpen}
//                                 onRefreshData={onRefreshGarphData}
//                             />
//                             {
//                                 tabTitle == 'Wind Direction' ? <Typography variant='body2' color={'error.main'} textAlign={"center"}>Nothing to show</Typography> :

//                                     <>
//                                         {
//                                             SensDataLoading
//                                                 ? <Typography variant='h5'>Please Wait............</Typography>
//                                                 : WmSensData?.length > 0
//                                                     ? <SingleLineChart data={datasets} labels={labels} />
//                                                     : <Typography textAlign={'center'} variant='body2' color={'error.main'}>Data Not Found</Typography>
//                                         }
//                                     </>
//                             }
//                         </Stack>
//                     </Grid>
//                     <Grid item md={4} sm={12}>
//                         <TempMeter title={tabTitle} data={SingleWmDash} />
//                     </Grid>
//                 </Grid>
//                 <Grid container>
//                     <Grid item md={12} sm={12}>
//                         <TwoHeadTable
//                             radiationName={tabTitle}
//                             WM_TYPE={WM_TYPE}
//                             TableHead={tabTitle == 'Solar Insolation' ? SolarInsolationHeader : tabTitle == 'Wind Direction' ? WindDirectionHeader : TableHead}
//                             TableData={WmSensData}
//                             ValueOf1={FromDate}
//                             ValueOf2={ToDate}
//                             onChangeValueOF1={(val) => setFromDate(val.target.value)}
//                             onChangeValueOF2={(val) => setToDate(val.target.value)}
//                             onRefreshData={onTblDataRefresh}
//                         />
//                     </Grid>
//                 </Grid>

//                 {/* Graph FullScreen */}
//                 <AppModal open={open}
//                     handleClose={handleClose}
//                 >
//                     <Typography variant='h5' textAlign={'center'} my={spacing(1)}>{tabTitle}</Typography>

//                     {
//                         SensDataLoading ? <CircularProgress /> : WmSensData?.length > 0 ? <SingleLineChart data={datasets} labels={labels} /> : <Typography textAlign={'center'} variant='body2' color={'error.main'}>Data Not Found</Typography>
//                     }

//                 </AppModal>

//                 {/* <div ref={messagesEndRef} /> */}

//             </Box>

//         </>
//     )
// }

// export default TabContent




import { Avatar, Box, Button, Card, CardActions, CardHeader, CircularProgress, CssBaseline, Grid, IconButton, Modal, Paper, Stack, Typography, colors, useMediaQuery, useTheme } from '@mui/material'
// import React from 'react'
// import { Stack } from 'react-bootstrap'
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import FilterStrip from './FilterStrip';
import SingleLineChart from './charts/SingleLineChart';
import TempMeter from './charts/TempMeter';
import TwoHeadTable from './TwoHeadTable';
import { DT1, DT2, WEB_KEY } from '../api/AxiosApi';
import { WmcContext } from '../context/WmcContext';
import { getDateTimeForTab2, getFromTo, getGraphDateTime } from '../utils';
import AppModal from './AppModal';
// let TableHead;

function TabContent({ WM_TYPE, tabTitle,menuItem }) {
    // const WM_TYPE = menuID
    const { WmSensData, SensDataLoading, getWmSENS, SingleWmDash } = useContext(WmcContext)
    const { palette, breakpoints, spacing } = useTheme()
    const lgs = useMediaQuery(breakpoints.down('xl'))

    const [FullScreen, setFullScreen] = useState(false)
    
    const LOGIN_ID = localStorage.getItem('LoginID')
    const LOC_CODE = localStorage.getItem('LCODE')
    const [width, setWidth] = useState();
    const [height, setHeight] = useState();
    const [FromDate, setFromDate] = useState(getDateTimeForTab2().LastDay)
    const [ToDate, setToDate] = useState(getDateTimeForTab2().Today)

   

    const [datasets, setDatasets] = useState([])
    const [labels, setLabels] = useState([])

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    // const [FromDate, setFromDate] = useState(getDateTimeForTab2().LastDay)
    // const [ToDate, setToDate] = useState(getDateTimeForTab2().Today)

    const LCODE = localStorage.getItem('LCODE')

    const PASS_KEY = "WERRRRRRRRRRR"

//   console.log("menuItemWms",menuItem)


  function onRefreshGarphData() {
        if (FromDate.length !== 0 && ToDate.length !== 0) {
             getWmSENS(LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY, WM_TYPE, FromDate, ToDate)
        } else {
            alert('please provide any date')
        }

    }

    function onTblDataRefresh() {
        if (FromDate.length !== 0 && ToDate.length !== 0) {
            // getWmSENS(LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY, WM_TYPE, FromDate, ToDate)
        } else {
            alert('please provide any date')
        }

    }


    const SolarInsolationHeader = [
        'Sn',
        'Date Time',
        'Solar Insolation',
        'Peak Irradiance',
        'Peak IRR.Time'
    ]

    const WindDirectionHeader = [
        'Sn',
        'Date Time',
        'Wind Direction'
    ]

    const TableHead = [
        'Sn',
        'Date Time',
        tabTitle,
        'Minimum Value',
        'Maximum Value',
        'Average Value'
    ]

    // const TableData = [
    //     {
    //         'S.No.': '1',
    //         'Date': '21/09/2023    10:10 AM',
    //         'Ambient Temperature (Celsius)': '39.593'
    //     },
    //     {
    //         'S.No.': '2',
    //         'Date': '21/09/2023    10:10 AM',
    //         'Ambient Temperature (Celsius)': '39.593'
    //     },
    //     {
    //         'S.No.': '3',
    //         'Date': '21/09/2023    10:10 AM',
    //         'Ambient Temperature (Celsius)': '39.593'
    //     },
    //     {
    //         'S.No.': '4',
    //         'Date': '21/09/2023    10:10 AM',
    //         'Ambient Temperature (Celsius)': '39.593'
    //     },
    //     {
    //         'S.No.': '5',
    //         'Date': '21/09/2023    10:10 AM',
    //         'Ambient Temperature (Celsius)': '39.593'
    //     }
    // ]

    // if (WmSensData?.length > 0) {
    //     TableHead = Object?.keys(WmSensData[0])
    // }


    function getRandomColor() {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }
    const styles = {
        IconStyle: {
            color: 'primary.main',
            fontSize: '0.8rem'
        }
    }


    useEffect(() => {
        if (WmSensData?.length > 0) {
            if (tabTitle == 'Solar Insolation') {
                setDatasets([
                    {
                        label: tabTitle,
                        data: WmSensData?.map(item => item[tabTitle]),
                        fill: false,
                        borderWidth: 0.9,
                        borderColor: 'green',
                        tension: 0.3,
                        pointRadius: 1,
                        pointHoverRadius: 1

                    },])
                setLabels(WmSensData?.map(item => item?.DateTime))

            } else {
                setDatasets([
                    {
                        label: tabTitle,
                        data: WmSensData?.map(item => item[tabTitle]),
                        fill: false,
                        borderWidth: 0.9,
                        borderColor: 'green',
                        tension: 0.3,
                        pointRadius: 1,
                        pointHoverRadius: 1
                    },
                    {
                        label: 'Min',
                        data: WmSensData?.map(item => item?.MIN_VALUE),
                        fill: false,
                        borderWidth: 0.9,
                        borderColor: 'yellow',
                        tension: 0.3,
                        pointRadius: 1,
                        pointHoverRadius: 1
                    },
                    {
                        label: 'Max',
                        data: WmSensData?.map(item => item?.MAX_VALUE),
                        fill: false,
                        borderColor: 'red',
                        tension: 0.3,
                        borderWidth: 0.9,
                        pointRadius: 1,
                        pointHoverRadius: 1

                    }, {
                        label: 'Avg',
                        data: WmSensData?.map(item => item?.AVG_VALUE),
                        fill: false,
                        borderColor: 'blue',
                        tension: 0.3,
                        borderWidth: 0.9,
                        pointRadius: 1,
                        pointHoverRadius: 1
                    }
                ])
                setLabels(WmSensData?.map(item => item?.DateTime))
            }

        }
    }, [WmSensData])

 
// console.log("tabtitle_wms",tabTitle)



    return (
        <>
            <CssBaseline />
            <Box bgcolor={'black'} py={spacing(1)}>
                <Grid container spacing={spacing(1)}>
                    <Grid item md={8} sm={12}>
                        <Stack spacing={spacing(1)}>

                            <FilterStrip
                                title={tabTitle}
                                ValueOf1={FromDate}
                                ValueOf2={ToDate}
                                onChangeValueOf1={(val) => setFromDate(val.target.value)}
                                onChangeValueOf2={(val) => setToDate(val.target.value)}
                                onFullScreen={handleOpen}
                                onRefreshData={onRefreshGarphData}
                            />
                            {
                                tabTitle == 'Wind Direction' ? <Typography variant='body2' color={'error.main'} textAlign={"center"}>Nothing to show</Typography> :

                                    <>
                                        {
                                            SensDataLoading
                                                ? <Typography variant='h5'>Please Wait............</Typography>
                                                : WmSensData?.length > 0
                                                    ? <SingleLineChart data={datasets} labels={labels} />
                                                    : <Typography textAlign={'center'} variant='body2' color={'error.main'}>Data Not Found</Typography>
                                        }
                                    </>
                            }
                        </Stack>
                    </Grid>

                    <Grid item md={4} sm={12}>
                        <TempMeter title={tabTitle} data={SingleWmDash} menuItem={menuItem}/>
                    </Grid>

                </Grid>
                <Grid container>
                    <Grid item md={12} sm={12}>
                        <TwoHeadTable
                            radiationName={tabTitle}
                            WM_TYPE={WM_TYPE}
                            TableHead={tabTitle == 'Solar Insolation' ? SolarInsolationHeader : tabTitle == 'Wind Direction' ? WindDirectionHeader : TableHead}
                            TableData={WmSensData}
                            ValueOf1={FromDate}
                            ValueOf2={ToDate}
                            onChangeValueOF1={(val) => setFromDate(val.target.value)}
                            onChangeValueOF2={(val) => setToDate(val.target.value)}
                            onRefreshData={onTblDataRefresh}
                        />
                    </Grid>
                </Grid>

                {/* Graph FullScreen */}
                <AppModal open={open}
                    handleClose={handleClose}
                >
                    <Typography variant='h5' textAlign={'center'} my={spacing(1)}>{tabTitle}</Typography>

                    {
                        SensDataLoading ? <CircularProgress /> : WmSensData?.length > 0 ? <SingleLineChart data={datasets} labels={labels} /> : <Typography textAlign={'center'} variant='body2' color={'error.main'}>Data Not Found</Typography>
                    }

                </AppModal>

                {/* <div ref={messagesEndRef} /> */}

            </Box>

        </>
    )
}

export default TabContent

